import { KrCard } from '@/common/card/KrCard';
import { KrChip } from '@/common/card/KrChip';
import { useFieldDefs } from '@/common/entityFramework/entityForm/FieldDefsContext';
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useForm } from '../FormContext';

export const EntityStatusCard = () => {
  const { fieldDefs } = useFieldDefs();
  const { formValues } = useForm();

  const statusFieldDefs = useMemo(
    () => fieldDefs?.filter((fieldDef) => fieldDef.section === 'Status') ?? [],
    [fieldDefs],
  );

  useMemo(() => {
    statusFieldDefs.forEach((statusFieldDef) => {
      const codeToEnumSpec = {};
      statusFieldDef.values?.forEach((enumSpec) => {
        codeToEnumSpec[enumSpec.code] = enumSpec;
      });
      statusFieldDef.codeToEnumSpec = codeToEnumSpec;
    });
  }, [statusFieldDefs]);

  let renderField = (fieldDef) => {
    let value = formValues[fieldDef.field];
    let enumSpec = fieldDef.codeToEnumSpec?.[value];

    return (
      <Stack
        key={fieldDef.field}
        direction="row"
        alignItems="center"
        width="100%"
        justifyContent="space-between"
        gap={2}
      >
        <Typography component="label" variant="subtitle1">
          {fieldDef.displayName}
        </Typography>
        {enumSpec && <KrChip label={enumSpec.displayName} icon={enumSpec.icon} color={enumSpec.color} />}
        {!enumSpec && (
          <Typography variant="body2" sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            —
          </Typography>
        )}
      </Stack>
    );
  };

  return (
    <KrCard minHeight={0} variant="bold">
      <Stack direction="column" width="100%" gap={2}>
        {statusFieldDefs.map((fieldDef) => renderField(fieldDef))}
      </Stack>
    </KrCard>
  );
};
